import * as ACTION_TYPES from '../constants/types';

const initialState = {
    message: '',
    error: null,
    dealerList: [],
    dealerDetails: {},
    warehouseList: [],
    warehouseDetails: {},
    inventoryByWarehouseList: [],
    selectedWarehouse: null,
    demandByWarehouseList : [],
    demandForSupplierWarehouseList : [],
    getDemandDetails : {}

    

    
}

const inventory = (state = initialState, action) => {

    switch (action.type) {
        case ACTION_TYPES.API_LIST_DEALER_S:
            return {
                ...state,
                dealerList: action.payload.data?.list ? action.payload.data?.list : [],
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.API_LIST_DEALER_F:
            return {
                ...state,
                dealerList: [],
                error: action.payload.data.message
            }
        case ACTION_TYPES.API_GET_DEALER_DETAILS_S:
            return {
                ...state,
                dealerDetails: action.payload.data ? action.payload.data : {},
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.API_GET_DEALER_DETAILS_F:
            return {
                ...state,
                dealerDetails: null,
                error: action.payload.data.message
            }
        //
        case ACTION_TYPES.API_LIST_WAREHOUSE_S:
            // console.log("action.payload.data",action.payload.data)
            return {
                ...state,
                warehouseList: action.payload.data ? action.payload.data : [],
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.API_LIST_WAREHOUSE_F:
            return {
                ...state,
                warehouseList: [],
                error: action.payload.data.message
            }
        case ACTION_TYPES.API_GET_WAREHOUSE_DETAILS_S:
            return {
                ...state,
                warehouseDetails: action.payload.data ? action.payload.data : {},
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.API_GET_WAREHOUSE_DETAILS_F:
            return {
                ...state,
                warehouseDetails: null,
                error: action.payload.data.message
            }

        case ACTION_TYPES.API_LIST_INVENTORY_BY_WAREHOUSE_S:
            // console.log("action.payload.data",action.payload.data)
            return {
                ...state,
                inventoryByWarehouseList: action.payload.data ? action.payload.data : [],
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.API_LIST_INVENTORY_BY_WAREHOUSE_F:
            return {
                ...state,
                inventoryByWarehouseList: [],
                error: action.payload.data.message
            }
        case 'SET_SELECTED_WAREHOUSE':
            return {
                ...state,
                selectedWarehouse: action.payload,
            };
        case ACTION_TYPES.API_LIST_DEMAND_BY_WAREHOUSE_S:
            // console.log("action.payload.data",action.payload.data)
            return {
                ...state,
                demandByWarehouseList: action.payload.data ? action.payload.data : [],
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.API_LIST_DEMAND_BY_WAREHOUSE_F:
            return {
                ...state,
                demandByWarehouseList: [],
                error: action.payload.data.message
            }
        case ACTION_TYPES.API_LIST_DEMAND_FOR_SUPPLIER_WAREHOUSE_S:
            // console.log("action.payload.data",action.payload.data)
            return {
                ...state,
                demandForSupplierWarehouseList: action.payload.data ? action.payload.data : [],
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.API_LIST_DEMAND_FOR_SUPPLIER_WAREHOUSE_F:
            return {
                ...state,
                demandForSupplierWarehouseList: [],
                error: action.payload.data.message
            }

        case ACTION_TYPES.API_GET_DEMAND_BY_ID_S:
            // console.log("action.payload.data",action.payload.data)
            return {
                ...state,
                getDemandDetails: action.payload.data ? action.payload.data : {},
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.API_GET_DEMAND_BY_ID_F:
            return {
                ...state,
                getDemandDetails: {},
                error: action.payload.data.message
            }



            


        //

        default:
            return state
    }

}

export default inventory;